import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import http from '../http';
import { useTranslation } from '../t';
import { inject, observer } from 'mobx-react';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';
import { passwordRegex, phoneRegex } from '../const';
import logo from '../assets/logo.png';
import ICP from '../components/ICP';
import CaptchaInput from '../components/CaptchaInput';
import C from '../colors';

const RegesiterPage = inject('snackbarStore')(observer(({ snackbarStore }) => {
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(undefined);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(undefined);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(undefined);
  const [captcha, setCaptcha] = useState('');
  const [captchaError, setCaptchaError] = useState(undefined);
  const [captchaID, setCaptchaID] = useState('');
  const [code, setCode] = useState('');
  const [codeError, setCodeError] = useState(false);
  const [countdownTime, setCountdownTime] = useState(null);
  const [openAgreement, setOpenAgreement] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const validatePhone = (v) => !v ? t('phone num can not be empty') : !phoneRegex.test(v) ? t('_Phone Rule') : '';
  const validatePassword = (v) => !v ? t('password can not be empty') : !passwordRegex.test(v) ? t('_Password Rule') : '';
  const validateConfirmPassword = (v) => !v ? t('password can not be empty') : v !== password ? t('Passwords do not match!') : '';

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'confirmPassword') { setConfirmPassword(value); setConfirmPasswordError(validateConfirmPassword(value)); }
    else if (name === 'password') { setPassword(value); setPasswordError(validatePassword(value)); }
    else if (name === 'phone') { setPhone(value); setPhoneError(validatePhone(value)); }
    else if (name === 'code') { setCode(value); setCodeError(!value || value.length !== 4); }
  };

  const handleSend = useCallback((event) => {
    event.preventDefault();
    const pe = validatePhone(phone);
    setPhoneError(pe);
    if (pe) return;
    http.post('/sendCodeForReg', { phone, captchaID }).then((res) => {
      if (res.status === 200) {
        snackbarStore.showSnackbar(t('Send successfully'));
        setCountdownTime(60);
        const timer = setInterval(() => {
          setCountdownTime(p => { if (p <= 1) { clearInterval(timer); return null; } return p - 1; });
        }, 1000);
      }
    }).catch(err => {
      const message = err?.response?.data?.error || '验证码发送失败，请稍后重试';
      const visibleMessage = ['Phone alreay exists', 'User alreay exists'].includes(message)
        ? '该手机号已注册'
        : message === 'Captcha error' ? '图形验证码错误或已过期' : message;
      if (visibleMessage === '该手机号已注册') setPhoneError(visibleMessage);
      else setCaptchaError(visibleMessage);
      snackbarStore.showSnackbar(visibleMessage, 'error');
    });
  }, [phone, captchaID, snackbarStore, t]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const pe = validatePhone(phone);
    const ce = captcha ? '' : t('Captcha can not be empty');
    const pwe = validatePassword(password);
    const cpwe = validateConfirmPassword(confirmPassword);
    const cde = code && code.length === 4 ? '' : t('Code format error');
    setPhoneError(pe); setCaptchaError(ce); setPasswordError(pwe); setConfirmPasswordError(cpwe); setCodeError(cde);
    if (pe || ce || pwe || cpwe || cde) return;
    http.post('/regesiter', { phone, password, code }).then(() => {
      snackbarStore.showSnackbar(t('Regesiter successfully'));
      navigate('/login');
    }).catch(err => {
      const message = err?.response?.data?.error || '注册失败，请稍后重试';
      let visibleMessage = message;
      if (['Phone alreay exists', 'User alreay exists'].includes(message)) {
        visibleMessage = '该手机号已注册';
        setPhoneError(visibleMessage);
      } else if (message === 'Code error or expired') {
        visibleMessage = '手机验证码错误或已过期';
        setCodeError(visibleMessage);
      } else if (message.startsWith('Password should be')) {
        visibleMessage = t('_Password Rule');
        setPasswordError(visibleMessage);
      }
      snackbarStore.showSnackbar(visibleMessage, 'error');
    });
  };

  const field = (label, name, value, error, type = 'text', placeholder) => (
    <div style={{ marginBottom: 18 }}>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 600, letterSpacing: 1.2, textTransform: 'uppercase', color: C.ink3, marginBottom: 6 }}>{label}</label>
      <input type={type} name={name} value={value} onChange={handleInputChange} placeholder={placeholder || label}
        style={{ width: '100%', padding: '12px 14px', borderRadius: 8, border: `1.5px solid ${error ? '#e88c7c' : C.hair}`, background: '#fff', fontFamily: C.sans, fontSize: 14, outline: 'none', color: C.ink, transition: 'border-color .2s' }}/>
      {error && <div style={{ fontSize: 11, color: '#c2412e', marginTop: 4 }}>{error}</div>}
    </div>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: C.sans }}>
      {/* Left panel */}
      <div className="login-panel" style={{ flex: 1, background: C.ink, display: 'none', position: 'relative', overflow: 'hidden', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 24 }}>
        <div style={{ position: 'absolute', fontSize: 180, fontFamily: C.serif, color: 'rgba(255,255,255,.04)', transform: 'rotate(-18deg)', whiteSpace: 'nowrap', pointerEvents: 'none' }}>图派</div>
        <div style={{ position: 'relative', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: C.brand, fontWeight: 600 }}>Picsect Studio</div>
        <div style={{ position: 'relative', fontFamily: C.serif, fontSize: 42, color: '#fff', lineHeight: 1.1, textAlign: 'center' }}>
          开始你的<br/><span style={{ fontStyle: 'italic', color: C.brand }}>摄影工作流</span>
        </div>
        <div style={{ position: 'relative', fontSize: 14, color: 'rgba(255,255,255,.45)', maxWidth: 300, textAlign: 'center', lineHeight: 1.6 }}>
          图派帮助摄影师管理选片、交付与客户沟通。免费试用。
        </div>
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, display: 'flex' }}>
          <div style={{ flex: 1, height: 3, background: C.brand }}/>
          <div style={{ flex: 1, height: 3, background: C.brand2 }}/>
          <div style={{ flex: 1, height: 3, background: '#F4A8C8' }}/>
        </div>
      </div>

      {/* Right form */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 32px', background: C.paper }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <img alt="图派" src={logo} style={{ width: 96, height: 96, objectFit: 'contain', marginBottom: 10 }}/>
            <h2 style={{ margin: 0, fontFamily: C.serif, fontSize: 28, fontWeight: 400, color: C.ink }}>{t('Create Account')}</h2>
            <p style={{ margin: '8px 0 0', fontSize: 13, color: C.ink2 }}>
              {t("Already have an account?")} <a href="/login" style={{ color: C.brand, textDecoration: 'none', fontWeight: 500 }}>{t('Login')}</a>
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {field(t('phone'), 'phone', phone, phoneError)}

            <CaptchaInput placeholder={t('Captcha')} error={!!captchaError} helperText={captchaError || undefined}
              onChange={handleInputChange} captcha={captcha} setCaptcha={setCaptcha} captchaID={captchaID} setCaptchaID={setCaptchaID}/>

            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, letterSpacing: 1.2, textTransform: 'uppercase', color: C.ink3, marginBottom: 6 }}>{t('Phone code')}</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input data-testid="register-sms-code" type="text" name="code" value={code} onChange={handleInputChange} placeholder={t('Phone code')}
                  style={{ flex: 1, padding: '12px 14px', borderRadius: 8, border: `1.5px solid ${codeError ? '#e88c7c' : C.hair}`, background: '#fff', fontFamily: C.sans, fontSize: 14, outline: 'none', color: C.ink }}/>
                <button onClick={handleSend} type="button" disabled={countdownTime !== null} style={{
                  padding: '12px 14px', borderRadius: 8, border: 'none', whiteSpace: 'nowrap',
                  background: countdownTime !== null ? C.hair2 : C.ink, color: '#fff',
                  fontFamily: C.sans, fontSize: 13, fontWeight: 500, cursor: countdownTime !== null ? 'default' : 'pointer',
                }}>{countdownTime !== null ? `${countdownTime}s` : t('Send Code')}</button>
              </div>
              {codeError && <div style={{ fontSize: 11, color: '#c2412e', marginTop: 4 }}>{codeError}</div>}
            </div>

            {field(t('Password'), 'password', password, passwordError, 'password')}
            {field(t('Confirm Password'), 'confirmPassword', confirmPassword, confirmPasswordError, 'password')}

            <div style={{ fontSize: 12, color: C.ink3, textAlign: 'center', marginBottom: 16 }}>
              {t("By clicking Sign up, you agree to our")}
              <span onClick={() => setOpenAgreement(true)} style={{ color: C.brand, cursor: 'pointer', marginLeft: 4, fontWeight: 500 }}>
                {t('Terms and Privacy Policy.')}
              </span>
            </div>

            <button data-testid="register-submit" type="submit" style={{
              width: '100%', padding: '14px', borderRadius: 10, border: 'none',
              background: C.brand, color: '#fff', fontFamily: C.sans, fontSize: 15, fontWeight: 500, cursor: 'pointer',
              boxShadow: `0 8px 24px -8px rgba(247,119,176,.5)`,
            }}>{t('Sign Up')}</button>
          </form>
        </div>

        {/* Agreement dialog */}
        {openAgreement && (
          <AgreementModal onClose={() => setOpenAgreement(false)}/>
        )}

        <div style={{ marginTop: 40 }}><ICP/></div>
      </div>

      <style>{`@media(min-width:720px){.login-panel{display:flex!important}}`}</style>
    </div>
  );
}));

function AgreementModal({ onClose }) {
  const [text, setText] = useState('');
  const { t } = useTranslation();
  React.useEffect(() => {
    axios.get('/agreement.md').then(res => setText(res.data));
  }, []);

  if (!text) return null;

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(26,22,20,.4)', display: 'grid', placeItems: 'center', zIndex: 9999 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 560, maxHeight: '80vh', background: C.paper, border: `1px solid ${C.hair}`, borderRadius: 14, overflow: 'auto', padding: '24px 28px', boxShadow: '0 24px 56px -16px rgba(26,22,20,.32)' }}>
        <h3 style={{ margin: '0 0 16px', fontFamily: C.serif, fontSize: 24, fontWeight: 400, color: C.ink }}>{t('User Agreement')}</h3>
        <div style={{ fontSize: 13, color: C.ink2, lineHeight: 1.7 }}><ReactMarkdown>{text}</ReactMarkdown></div>
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <button onClick={onClose} style={{ padding: '8px 20px', borderRadius: 7, border: `1px solid ${C.hair2}`, background: '#fff', fontFamily: C.sans, fontSize: 13, cursor: 'pointer' }}>{t('Close')}</button>
        </div>
      </div>
    </div>
  );
}

export default RegesiterPage;
